export default {
  head: {
    title: 'Payout operations billing',
    action: {
      search: {
        tooltip: 'Search single operation by Operation Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search Payout billing operation'
    },
    details: {
      title: 'Payout operation details'
    }
  }
};
